import * as Immutable from 'immutable';

import { AlphaTabType } from '../constants';

import { initialSelectedColumns } from './initialColumnsTable';

export const alphaStatus = Immutable.fromJS(['is', 'os', 'prod']);
export const columnsNumberTypes = Immutable.fromJS(['decimal', 'permyriad', 'percent', 'integer', 'amount', 'permillion']);

let rangeFields: string[] = [];
let datetimeFields: string[] = [];
let percentAndPermyriadFields: string[] = [];
let millionFields: string[] = [];

// @ts-ignore
initialSelectedColumns(AlphaTabType.SUPER_SELECTION, ['CONSULTANT']).forEach((column: any) => {
  if (column.type === 'percent' || column.type === 'permyriad') {
    column.possibleParents.map((possibleParent: any) => {
      percentAndPermyriadFields = percentAndPermyriadFields.concat(`${possibleParent}.${column.id}`);
    });
  }

  if (column.type === 'permillion') {
    column.possibleParents.map((possibleParent: any) => {
      millionFields = millionFields.concat(`${possibleParent}.${column.id}`);
    });
  }

  if (columnsNumberTypes.includes(column.type)) {
    rangeFields = rangeFields.concat(column.id);
  }

  if (column.type === 'datetime') {
    datetimeFields = datetimeFields.concat(column.id);
  }
});

export const AlphaRangeFilters = rangeFields;
export const MillionFilters = millionFields;
export const PercentAndPermyriadFilters = percentAndPermyriadFields;
export const DatetimeFilters: any = datetimeFields;
export const alphacolors = ['NONE', 'RED', 'YELLOW', 'GREEN', 'BLUE', 'PURPLE'];
